//-----------Basic imports----------------------------
import ROUTES from '../../route/routes'
import { Route, Switch } from 'react-router-dom'

import AddNotifications from './CreateNew'
import AllNotification from './AllNotification/index'
import NotFound from '../../pages/NotFound'

const Notifications = () => {
  return (
    <Switch>
      <Route exact path={ROUTES.notifications.list} component={AllNotification} />
      <Route path={ROUTES.notifications.addNotifications} component={AddNotifications} />
      <Route path={ROUTES.notFound} component={NotFound} />
    </Switch>
  )
}

export default Notifications
